import { createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-795158a3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container overflow-y-scroll h-screen pb-48 max-h-[calc(100vh-8rem)]" }
const _hoisted_2 = { class: "flex w-full max-w-md" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "emailInput",
  class: "me-2"
}, "Email:", -1))
const _hoisted_4 = ["value"]
const _hoisted_5 = { class: "mt-2 flex flex-col w-full max-w-md" }
const _hoisted_6 = { class: "flex w-full" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "nameInput",
  class: "me-2"
}, "Name:", -1))
const _hoisted_8 = ["readonly"]
const _hoisted_9 = { class: "ms-[24px] flex" }
const _hoisted_10 = {
  key: 0,
  class: "flex w-full text-accent",
  id: "nameInputFeedback"
}
const _hoisted_11 = { class: "ms-auto me-[50px]" }
const _hoisted_12 = { class: "mt-2 flex flex-col w-full max-w-md" }
const _hoisted_13 = { class: "flex w-full" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "surnameInput",
  class: "me-2"
}, "Surname:", -1))
const _hoisted_15 = ["readonly"]
const _hoisted_16 = { class: "ms-[24px] flex" }
const _hoisted_17 = {
  key: 0,
  class: "flex w-full text-accent"
}
const _hoisted_18 = {
  class: "ms-auto me-[50px] invalid-feedback",
  id: "surnameInputFeedback"
}
const _hoisted_19 = { class: "flex flex-col xl:flex-row w-full mt-2" }
const _hoisted_20 = { class: "lg:basis-1/3" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Image:", -1))
const _hoisted_22 = ["src"]
const _hoisted_23 = { class: "mt-4 xl:mt-0 xl:ms-4 xl:basis-1/3" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-full" }, "Change image:", -1))
const _hoisted_25 = { class: "flex flex-row mt-2 max-w-md" }
const _hoisted_26 = {
  key: 0,
  class: "mt-4 xl:mt-0 xl:ms-4 xl:basis-1/3"
}
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Result:", -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "h-0.5 mt-4 bg-accent border-0 dark:bg-accent-700" }, null, -1))
const _hoisted_29 = { class: "mt-4 w-full max-w-md" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon_edit = _resolveComponent("icon-edit")!
  const _component_icon_save = _resolveComponent("icon-save")!
  const _component_cropper = _resolveComponent("cropper")!
  const _component_preview = _resolveComponent("preview")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("input", {
        type: "text",
        readonly: "",
        class: "ms-auto px-2 rounded-md me-[44px] text-black",
        id: "emailInput",
        value: _ctx.userStore.user?.email
      }, null, 8, _hoisted_4)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _withDirectives(_createElementVNode("input", {
          type: "text",
          readonly: _ctx.userFormElementsState.nameInputLock,
          class: _normalizeClass(
          _ctx.userFormElementsState.nameInputLock
            ? 'ms-auto px-2 rounded-md text-black '
            : `ms-auto px-2 rounded-md text-black ${
                _ctx.userFormElementsState.nameValidation.isValid
                  ? 'is-valid'
                  : 'is-invalid'
              }`
        ),
          id: "nameInput",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((this.userFormElementsState.name) = $event)),
          "aria-describedby": "nameInputFeedback"
        }, null, 10, _hoisted_8), [
          [_vModelText, this.userFormElementsState.name]
        ]),
        _createElementVNode("div", _hoisted_9, [
          (_ctx.userFormElementsState.nameInputLock)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "my-auto",
                type: "button",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeName()))
              }, [
                _createVNode(_component_icon_edit)
              ]))
            : (_openBlock(), _createElementBlock("button", {
                key: 1,
                type: "button",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.saveName()))
              }, [
                _createVNode(_component_icon_save)
              ]))
        ])
      ]),
      (this.userFormElementsState.nameValidation.message)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, _toDisplayString(this.userFormElementsState.nameValidation.message), 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        _hoisted_14,
        _withDirectives(_createElementVNode("input", {
          type: "text",
          readonly: _ctx.userFormElementsState.surnameInputLock,
          class: _normalizeClass(
          _ctx.userFormElementsState.surnameInputLock
            ? 'ms-auto px-2 rounded-md text-black'
            : `ms-auto px-2 rounded-md text-black ${
                _ctx.userFormElementsState.surnameValidation.isValid
                  ? 'is-valid'
                  : 'is-invalid'
              }`
        ),
          id: "surnameInput",
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.userFormElementsState.surname) = $event)),
          "aria-describedby": "surnameInputFeedback"
        }, null, 10, _hoisted_15), [
          [_vModelText, _ctx.userFormElementsState.surname]
        ]),
        _createElementVNode("div", _hoisted_16, [
          (_ctx.userFormElementsState.surnameInputLock)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "my-auto",
                type: "button",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.changeSurname()))
              }, [
                _createVNode(_component_icon_edit)
              ]))
            : (_openBlock(), _createElementBlock("button", {
                key: 1,
                type: "button",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.saveSurname()))
              }, [
                _createVNode(_component_icon_save)
              ]))
        ])
      ]),
      (this.userFormElementsState.surnameValidation.message)
        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, _toDisplayString(this.userFormElementsState.surnameValidation.message), 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_19, [
      _createElementVNode("div", _hoisted_20, [
        _hoisted_21,
        _createElementVNode("img", {
          class: "mt-2",
          src: this.userStore.user?.picture?.url,
          alt: ""
        }, null, 8, _hoisted_22)
      ]),
      _createElementVNode("div", _hoisted_23, [
        _hoisted_24,
        _createVNode(_component_cropper, {
          ref: "cropper",
          class: "cropper mt-2",
          src: _ctx.imageForUpload.src,
          onChange: _ctx.changeUserImage,
          debounce: false,
          "stencil-props": {
            aspectRatio: 1,
          },
          canvas: {
            height: 600,
            width: 600
          }
        }, null, 8, ["src", "onChange"]),
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("input", {
            id: "userImageUpload",
            "aria-describedby": "userImageUpload",
            "aria-label": "Upload",
            onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.loadImage($event))),
            type: "file",
            ref: "file",
            accept: "image/*"
          }, null, 544),
          _createElementVNode("button", {
            class: "text-accent font-bold",
            type: "button",
            onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.uploadImage && _ctx.uploadImage(...args)))
          }, "Upload")
        ])
      ]),
      (_ctx.result.image)
        ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
            _hoisted_27,
            _createVNode(_component_preview, {
              class: "mt-2",
              width: 120,
              height: 120,
              image: _ctx.result.image,
              coordinates: _ctx.result.coordinates
            }, null, 8, ["image", "coordinates"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _hoisted_28,
    _createElementVNode("div", _hoisted_29, [
      _createElementVNode("button", {
        class: "ms-0 text-accent font-bold",
        type: "button",
        onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)))
      }, "Logout")
    ])
  ]))
}